interface SAHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export default function SAHeader({ title, subtitle, actions }: SAHeaderProps) {
  return (
    <div className="flex items-center justify-between px-4 md:px-8 py-4 md:py-5 border-b border-slate-200 bg-white sticky top-0 z-10">
      {/* Left: title */}
      <div>
        <h1 className="text-slate-900 font-semibold text-lg tracking-tight">{title}</h1>
        {subtitle && <p className="text-slate-500 text-xs mt-0.5">{subtitle}</p>}
      </div>

      {/* Right: actions */}
      {actions && (
        <div className="flex items-center gap-3">{actions}</div>
      )}
    </div>
  );
}
